app.controller('popupTakenDrugCreateController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel',
                'applicationModel', 'visitModel', 'userModel', 'patientModel', 'prescribedDrugModel',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel,
              prescribedDrugModel) {

        function setData() {
            $scope.takenDrug = new PrescribedDrugVO();
            $scope.takenDrug.count = 1;
            $scope.takenDrug.patient = new PatientVO();
            $scope.takenDrug.patient.id = $state.params.patientId;
            $scope.takenDrug.attachments = [];

            $scope.forms = {
                takenDrugForm: null
            };

            $scope.vm = {
                p2Drug: null
            };

            $scope.takenDrugActionType = 'save';
            $scope.presentDate = new Date();

            $scope.p2Drug = null;
            $scope.p2DrugPackage = null;
            $scope.packagesOptions = null;
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$watch('vm.p2Drug', function (newVal) {
                if(newVal) {
                    $scope.takenDrug.drug = new DrugVO();
                    $scope.takenDrug.drug.name = newVal.name;
                    $scope.takenDrug.drug.commonName = newVal.commonName;
                    $scope.takenDrug.drug.form = newVal.form;
                    $scope.takenDrug.drug.strength = newVal.strength;
                    $scope.takenDrug.drug.packages = newVal.packages.map(function (p) {
                        return p.drugPackage;
                    });
                    if($scope.takenDrug.drug.packages.length === 1) {
                        $scope.takenDrug.drug.packing = $scope.takenDrug.drug.packages[0];
                    }

                } else {
                    $scope.takenDrug.drug = null;
                    $scope.packagesOptions = null;
                }
            });

        }

        function setActions() {
            $scope.takenDrugAction = function () {

                $scope.forms.takenDrugForm.$setSubmitted();
                if ($scope.forms.takenDrugForm.$valid) {
                    $scope.actionInProgress = true;

                    prescribedDrugModel.save($scope.takenDrug).then(function() {
                        $scope.actionInProgress = false;
                        $mdDialog.hide();
                    })
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            }
        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
